/* ============================================================
   SAINT GRAAL · mobile navigation, and the sticky offset
   Added 2026-09-23.

   Two faults, both only visible on a phone.

   1. Below 880px the CSS hid .nav-left and .nav-right and put
      nothing in their place, so the only navigation on any phone
      was the logo. Every link was still in the DOM at zero width.
      This adds the button and the panel that should have been
      there. It reuses the existing links rather than duplicating
      the menu, so the two can never drift apart.

   2. The product sub-nav sticks at a hardcoded top of 78px while
      the fixed header measures 94 to 100px, so 22px of it sat
      behind the header the whole way down the page. The header's
      real height is now published as --sg-nav-h and the CSS uses
      it, so the two stay in step at any breakpoint and through the
      header's own shrink-on-scroll.
   ============================================================ */
(function () {
  'use strict';

  var nav = document.getElementById('topnav');
  if (!nav) return;

  /* ---- 2. keep the sticky sub-nav clear of the header ---- */
  function publishNavHeight() {
    var h = Math.round(nav.getBoundingClientRect().height);
    if (h > 0) document.documentElement.style.setProperty('--sg-nav-h', h + 'px');
  }
  publishNavHeight();
  window.addEventListener('resize', publishNavHeight);
  window.addEventListener('orientationchange', publishNavHeight);
  // the header shrinks once the page scrolls, so re-measure after it settles
  window.addEventListener('scroll', function () {
    window.clearTimeout(publishNavHeight._t);
    publishNavHeight._t = window.setTimeout(publishNavHeight, 160);
  }, { passive: true });

  /* ---- 1. the mobile menu ---- */
  var left = nav.querySelector('.nav-left');
  var right = nav.querySelector('.nav-right');
  if (!left) return;

  var btn = document.createElement('button');
  btn.className = 'nav-burger';
  btn.setAttribute('aria-label', 'Open menu');
  btn.setAttribute('aria-expanded', 'false');
  btn.setAttribute('aria-controls', 'sg-mobile-menu');
  btn.type = 'button';
  btn.innerHTML = '<span></span><span></span><span></span>';
  nav.insertBefore(btn, nav.firstChild);

  var panel = document.createElement('div');
  panel.className = 'nav-mobile';
  panel.id = 'sg-mobile-menu';
  panel.hidden = true;

  // Build from the links already in the header. Products come out of the
  // Origins dropdown with their numerals; everything else keeps its label.
  var html = '<div class="nav-mobile-inner">';
  var dd = left.querySelector('.nav-dropdown');
  if (dd) {
    html += '<div class="nav-mobile-group"><div class="nav-mobile-label">Origins</div>';
    Array.prototype.forEach.call(dd.children, function (a) {
      if (a.tagName !== 'A') return;
      var num = a.querySelector('.nav-dd-num');
      var name = a.querySelector('.nav-dd-name') || a.querySelector('.nav-dd-rare-name');
      var text = name ? name.textContent.trim() : a.textContent.trim();
      html += '<a href="' + a.getAttribute('href') + '">' +
              (num ? '<span class="nav-mobile-num">' + num.textContent.trim() + '</span>' : '') +
              '<span>' + text + '</span></a>';
    });
    html += '</div>';
  }
  html += '<div class="nav-mobile-group">';
  Array.prototype.forEach.call(left.children, function (el) {
    if (el.tagName === 'A') {
      html += '<a href="' + el.getAttribute('href') + '"><span>' + el.textContent.trim() + '</span></a>';
    }
  });
  if (right) {
    Array.prototype.forEach.call(right.children, function (el) {
      if (el.tagName === 'A') {
        html += '<a href="' + el.getAttribute('href') + '"><span>' +
                el.textContent.trim().replace(/\s+/g, ' ') + '</span></a>';
      }
    });
  }
  html += '</div></div>';
  panel.innerHTML = html;
  nav.parentNode.insertBefore(panel, nav.nextSibling);

  var open = false;
  function setOpen(v) {
    open = v;
    btn.setAttribute('aria-expanded', String(v));
    btn.setAttribute('aria-label', v ? 'Close menu' : 'Open menu');
    btn.classList.toggle('is-open', v);
    panel.hidden = !v;
    // let the panel paint before the transition starts
    if (v) window.requestAnimationFrame(function () { panel.classList.add('is-open'); });
    else panel.classList.remove('is-open');
    document.body.style.overflow = v ? 'hidden' : '';
  }

  btn.addEventListener('click', function () { setOpen(!open); });
  panel.addEventListener('click', function (e) {
    if (e.target.closest('a')) setOpen(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && open) { setOpen(false); btn.focus(); }
  });
  // a resize back to desktop must not leave the body locked
  window.addEventListener('resize', function () {
    if (open && window.innerWidth > 880) setOpen(false);
  });
})();
